// 域名配置和检测工具

// 无法备案的域名后缀列表（注意：某些域名可能已备案）
export const UNREGISTERED_SUFFIXES = [
  '.tk', '.ml', '.ga', '.cf', '.gq', '.pw', '.app',
  '.dev', '.test', '.local'
];

// 特殊已备案域名列表（已知已备案的域名）
export const REGISTERED_SPECIAL_DOMAINS = [
  'fangxiaojia.vip',  // 主域名已备案
  'form.fangxiaojia.vip'  // 子域名
];

// 常见的可备案域名后缀
export const REGISTERED_SUFFIXES = [
  '.com', '.cn', '.net', '.org', '.com.cn', '.net.cn', 
  '.org.cn', '.gov.cn', '.edu.cn', '.ac.cn', '.mil.cn',
  '.biz', '.info', '.name', '.pro', '.asia', '.mobi'
];

/**
 * 检查域名是否已备案
 * @param {string} hostname - 域名
 * @returns {boolean} 是否已备案
 */
export function isDomainRegistered(hostname) {
  if (!hostname) return false;
  
  // 检查是否是已知已备案的特殊域名
  if (REGISTERED_SPECIAL_DOMAINS.includes(hostname)) {
    return true;
  }
  
  // 检查是否是已备案域名的子域名
  const registeredMainDomains = ['fangxiaojia.vip']; // 已知已备案的主域名
  for (const mainDomain of registeredMainDomains) {
    if (hostname.endsWith('.' + mainDomain) || hostname === mainDomain) {
      return true;
    }
  }
  
  // 检查是否包含无法备案的后缀
  const hasUnregisteredSuffix = UNREGISTERED_SUFFIXES.some(suffix => 
    hostname.includes(suffix)
  );
  
  if (hasUnregisteredSuffix) {
    return false;
  }
  
  // 检查是否包含可备案的后缀
  const hasRegisteredSuffix = REGISTERED_SUFFIXES.some(suffix => 
    hostname.includes(suffix)
  );
  
  if (hasRegisteredSuffix) {
    return true;
  }
  
  // 本地开发环境
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.includes('ngrok')) {
    return true;
  }
  
  // 默认返回true，让用户自己判断
  return true;
}

/**
 * 获取域名类型描述
 * @param {string} hostname - 域名
 * @returns {string} 域名类型描述
 */
export function getDomainTypeDescription(hostname) {
  if (!hostname) return '未知域名';
  
  // 检查是否是已备案域名的子域名
  const registeredMainDomains = ['fangxiaojia.vip'];
  for (const mainDomain of registeredMainDomains) {
    if (hostname.endsWith('.' + mainDomain)) {
      return `子域名（继承主域名 ${mainDomain} 的备案状态）`;
    }
    if (hostname === mainDomain) {
      return `主域名（已备案）`;
    }
  }
  
  // 检查是否是子域名
  const parts = hostname.split('.');
  if (parts.length > 2) {
    return '子域名（继承主域名备案状态）';
  }
  
  // 检查是否是本地开发环境
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return '本地开发环境';
  }
  
  if (hostname.includes('ngrok')) {
    return 'Ngrok隧道（开发测试用）';
  }
  
  // 检查后缀类型
  for (const suffix of UNREGISTERED_SUFFIXES) {
    if (hostname.includes(suffix)) {
      return `无法备案域名（${suffix}后缀）`;
    }
  }
  
  for (const suffix of REGISTERED_SUFFIXES) {
    if (hostname.includes(suffix)) {
      return `可备案域名（${suffix}后缀）`;
    }
  }
  
  return '其他域名类型';
}

/**
 * 获取微信分享链接
 * @param {string} hostname - 域名
 * @param {string} formId - 表单ID
 * @returns {string} 分享链接
 */
export function getWechatShareLink(hostname, formId) {
  // 直接返回当前页面URL，不再使用专门的分享页面
  return window.location.href;
}

/**
 * 检查是否需要显示域名警告
 * @param {string} hostname - 域名
 * @returns {boolean} 是否需要显示警告
 */
export function shouldShowDomainWarning(hostname) {
  return !isDomainRegistered(hostname);
}

/**
 * 获取域名建议
 * @param {string} hostname - 当前域名
 * @returns {string} 建议信息
 */
export function getDomainSuggestion(hostname) {
  if (isDomainRegistered(hostname)) {
    return '当前域名配置正确，微信分享功能应该可以正常工作。';
  }
  
  return `建议将域名更换为已备案域名的子域名，例如：
  - form.yourdomain.com
  - form.yourdomain.cn
  - form.yourdomain.net
  
  子域名会自动继承主域名的备案状态。`;
} 